import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldHiddenInputComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldHiddenInputComponent, _super);
    function FormlyFieldHiddenInputComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldHiddenInputComponent;
}(FieldType));
export { FormlyFieldHiddenInputComponent };
